import { useEffect, useState } from 'react'
import { Save } from 'lucide-react'
import { bidWorkupService } from '../../../shared/api'

/**
 * AN AWARD NEEDS THE SIGNED PROPOSAL (Capex completion plan C2, item 8; audit A13) - a company setting that ships
 * BLANK: not required, as every award ran before. Required, an estimate is awarded only when the customer has signed
 * a proposal of it as it stands; one changed since they signed is refused in words. Picked, never typed. Whatever
 * this says, the Award page warns when the estimate changed since the customer signed.
 */
export const AWARD_SIGNATURE_CHOICES = [
  { value: '', label: 'Not required (as before) - the Award page still says whether the customer signed, and warns if the estimate changed since' },
  { value: 'yes', label: "Required - an award needs the customer's signed proposal of the estimate as it stands" },
]

export default function AwardSignatureSetting({ canEdit }) {
  const [stored, setStored] = useState(null)
  const [value, setValue] = useState('')
  const [busy, setBusy] = useState(false)
  const [said, setSaid] = useState(null)

  useEffect(() => {
    let cancelled = false
    bidWorkupService.getSettings()
      .then((s) => { if (!cancelled) { const v = s?.award_needs_signed_proposal || ''; setStored(v); setValue(v) } })
      .catch(() => { if (!cancelled) setSaid('The setting could not be read just now.') })
    return () => { cancelled = true }
  }, [])

  const save = async () => {
    setBusy(true); setSaid(null)
    try {
      const s = await bidWorkupService.updateSettings({ award_needs_signed_proposal: value })
      const v = s?.award_needs_signed_proposal || ''
      setStored(v); setValue(v); setSaid('Saved.')
    } catch (err) {
      setSaid(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail || 'It was not saved.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm space-y-3" data-testid="award-signature-setting">
      <div>
        <h2 className="font-semibold text-gray-800">An award needs the signed proposal</h2>
        <p className="text-sm text-gray-500 mt-0.5">Blank is not required, as before.</p>
      </div>
      <select value={value} disabled={!canEdit || stored === null} onChange={(e) => setValue(e.target.value)}
              aria-label="An award needs the signed proposal" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm">
        {AWARD_SIGNATURE_CHOICES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
      </select>
      {canEdit ? (
        <button type="button" onClick={save} disabled={busy || value === stored}
                className="flex items-center space-x-2 px-5 py-2 bg-bfs-maroon text-white rounded-lg text-sm font-semibold disabled:opacity-50">
          <Save className="h-4 w-4" /><span>{busy ? 'Saving…' : 'Save'}</span>
        </button>
      ) : <p className="text-xs text-gray-400">Only administrators can change this.</p>}
      {said ? <p className="text-sm text-gray-600" role="status">{said}</p> : null}
    </div>
  )
}
